import rewriteHttp from '@utils/rewriteHttp';

export const buildRoomGallery = (
  urls: (string | null | undefined)[],
  title: string,
  fallbackImageUrl?: string
) => {
  const roomImages = urls.filter((url): url is string => !!url);
  const fallbackImages = fallbackImageUrl ? [fallbackImageUrl] : [];
  const sources = roomImages.length ? roomImages : fallbackImages;

  return sources.map((src, index) => ({
    src: rewriteHttp(src),
    alt: sources.length > 1 ? `${title} (${index + 1}/${sources.length})` : title,
  }));
};
